import { render, staticRenderFns } from "./ArticleHeadline.vue?vue&type=template&id=04103e9e&scoped=true&"
import script from "./ArticleHeadline.vue?vue&type=script&lang=ts&"
export * from "./ArticleHeadline.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleHeadline.vue?vue&type=style&index=0&id=04103e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04103e9e",
  null
  
)

export default component.exports